module.exports = __webpack_public_path__ + "static/media/S_S03.4c060a90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_S03.png
// module id = 137
// module chunks = 0